import type { StopReason } from "./streamTracker";
// Pause/resume comes from userIntent in usePlayerStreamAnalytics; this bus
// carries terminal boundaries that require a new play on audible confirmation.
type PlayBoundaryReason = Exclude<StopReason, "pause">;
/** Explicit player boundaries, never inferred from a seek/progress discontinuity. */
export function createPlayLifecycle() {
  const seekListeners = new Set<() => void>();
  const listeners = new Set<(reason: PlayBoundaryReason) => void>();
  return {
    seek() {
      seekListeners.forEach((listener) => listener());
    },
    subscribeSeek(listener: () => void) {
      seekListeners.add(listener);
      return () => {
        seekListeners.delete(listener);
      };
    },
    end(reason: PlayBoundaryReason) {
      listeners.forEach((listener) => listener(reason));
    },
    subscribe(listener: (reason: PlayBoundaryReason) => void) {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
  };
}

export type PlayLifecycle = ReturnType<typeof createPlayLifecycle>;
